module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body"
  }, [(_vm.supervisorTerms) ? _c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.supervisorTerms), function(term) {
    return _c('div', [_c('h4', {
      staticClass: "cursor-pointer",
      on: {
        "click": function($event) {
          _vm.selectedTerm === term.id ? _vm.selectedTerm = null : _vm.selectedTerm = term.id
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(term.name) + "\n\t\t\t\t\t"), (_vm.selectedTerm === term.id) ? _c('i', {
      staticClass: "fa fa-caret-down"
    }) : _c('i', {
      staticClass: "fa fa-caret-right"
    })]), _vm._v(" "), (_vm.selectedTerm === term.id) ? _c('div', [_c('table', {
      staticClass: "table table-striped table-bordered"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), (term.type === 'intermediate' || term.type === 'advanced') ? _c('th', [_vm._v("Path")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Online Only")])])]), _vm._v(" "), _c('tbody', _vm._l((term.events), function(event) {
      return _c('tr', [_c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(event.name) + "\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.eventDate({
        termStartDate: term.startDate,
        timeFromStart: event.timeFromStart,
        timeUnit: event.timeUnit,
        duration: event.duration
      })) + "\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), (term.type === 'intermediate' || term.type === 'advanced') ? _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(event.path) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(event.description) + "\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(event.ignoreCampus ? 'Yes' : '') + "\n\t\t\t\t\t\t\t\t")])])
    })), _vm._v(" "), _c('tfoot')])]) : _vm._e()])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-83eb8bc4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/SupervisorJourney.vue
// module id = 2096
// module chunks = 2